import { render, staticRenderFns } from "./CheckboxParentItem.vue?vue&type=template&id=60d94645"
import script from "./CheckboxParentItem.vue?vue&type=script&lang=js"
export * from "./CheckboxParentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports